import {fetchGet} from "../services/api";
import {ICompany} from "../config/company";

export const searchCompanies = (query: string): Promise<ICompany[]> => {
    return fetchGet( '/companies/search', {query})
        .then(response => response.json())
        .then(data => data.data);
};
